export default {
	recvGetDeomTestResult: 'recvGetDeomTestResult',
};
